module.exports = __webpack_public_path__ + "static/media/Search.9fcf80e4.svg";